import React from 'react'
import { useIntl } from 'react-intl'
import LineClockDollarIcon from 'LuxKit/Icons/line/LineClockDollarIcon'
import Pill from 'LuxKit/Pill'
import useOptimizelyExperiment from 'hooks/Optimizely/useOptimizelyExperiment'
import { OptimizelyFeatureFlags } from 'constants/optimizely'

function PayAtPropertyPill({ hasMultipleOptions = true, doNotShowOnSearchPage = false }: { doNotShowOnSearchPage?: boolean, hasMultipleOptions?: boolean }) {
  const intl = useIntl()
  const isFeatureEnabled = !!useOptimizelyExperiment(OptimizelyFeatureFlags.croPayAtProperty)

  if (doNotShowOnSearchPage) {
    return null
  }

  if (!isFeatureEnabled) {
    return null
  }

  const payAtPropertyAvailableLabel = intl.formatMessage({
    id: 'NCYkcQMU8Vp03pyyZzyc',
    defaultMessage: 'Pay at property available',
    description: 'Label for pay at property pill when multiple payment options exist',
  })

  const payAtPropertyLabel = intl.formatMessage({
    id: 'e0ogjGxyCSqJ0OCSOwtO',
    defaultMessage: 'Pay at property',
    description: 'Form field label for pay at property pill within the travel booking interface',
  })

  return (
    <Pill startIcon={<LineClockDollarIcon />} kind="tertiary" variant="primary">
      {hasMultipleOptions ? payAtPropertyAvailableLabel : payAtPropertyLabel}
    </Pill>
  )
}

export default PayAtPropertyPill
